export const messages = {
  en: {
    menuCatalog: {
      search: {
        title: 'Search Condition',
        name: 'name',
        icon: 'icon',
        seq: 'seq',
        storeType: 'storeType',
        url: 'url',
        isShow: 'isShow',
        createTime: 'createTime',
        placeholder: 'Please enter menuCatalog name'
      },
      list: {
        title: 'menuCatalog List'
      },
      dialog: {
        addTitle: 'Add MenuCatalog',
        editTitle: 'Edit MenuCatalog',
        delTitle: 'Delete MenuCatalog',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        caId: 'caId',
        name: 'name',
        icon: 'icon',
        seq: 'seq',
        storeType: 'storeType',
        url: 'url',
        isShow: 'isShow',
        createTime: 'createTime',
      },
      table: {
        caId: 'caId',
        name: 'name',
        icon: 'icon',
        seq: 'seq',
        storeType: 'storeType',
        url: 'url',
        isShow: 'isShow',
        createTime: 'createTime',
      },
      validate: {
        caId: 'Please enter caId',
        name: 'Please enter name',
        icon: 'Please enter icon',
        seq: 'Please enter seq',
        url: 'Please enter url',
        isShow: 'Please enter isShow',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add MenuCatalog success'
      },
      edit: {
        success: 'Edit MenuCatalog success'
      },
      delete: {
        success: 'Delete MenuCatalog success',
        confirm: 'Are you sure to delete this menuCatalog?'
      },
      fetchError: 'Failed to fetch menuCatalog list',
      menuGropBtn:'menu group'
    }
  },
  zh: {
    menuCatalog: {
      search: {
        title: '查询条件',
        name: '菜单组名称',
        icon: '图标',
        seq: '顺序',
        storeType: '商户类型',
        url: '页面',
        isShow: '是否显示',
        createTime: '创建时间',
        placeholder: '请输入菜单目录名称'
      },
      list: {
        title: '菜单目录'
      },
      dialog: {
        addTitle: '添加菜单目录',
        editTitle: '编辑菜单目录',
        delTitle: '删除菜单目录',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        caId: '目录名称',
        name: '菜单组名称',
        icon: '图标',
        seq: '顺序',
        storeType: '商户类型',
        url: '页面',
        isShow: '是否显示',
        createTime: '创建时间',
      },
      table: {
        caId: '目录名称',
        name: '菜单组名称',
        icon: '图标',
        seq: '顺序',
        storeType: '商户类型',
        url: '页面',
        isShow: '是否显示',
        createTime: '创建时间',
      },
      validate: {
        caId: '请输入目录名称',
        name: '请输入菜单组名称',
        icon: '请输入图标',
        seq: '请输入顺序',
        url: '请输入页面',
        isShow: '请输入是否显示',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加菜单目录成功'
      },
      edit: {
        success: '编辑菜单目录成功'
      },
      delete: {
        success: '删除菜单目录成功',
        confirm: '确认删除该菜单目录吗？'
      },
      fetchError: '获取菜单目录列表失败',
      menuGropBtn:'菜单组'
    }
  },
  'zh-TW': {
    menuCatalog: {
      search: {
        title: '查詢條件',
        name: '菜單組名稱',
        icon: '圖標',
        seq: '順序',
        storeType: '商戶類型',
        url: '頁面',
        isShow: '是否顯示',
        createTime: '創建時間',
        placeholder: '請輸入菜單目錄名稱'
      },
      list: {
        title: '菜單目錄'
      },
      dialog: {
        addTitle: '添加菜單目錄',
        editTitle: '編輯菜單目錄',
        delTitle: '刪除菜單目錄',
        cancel: '取消',
        confirm: '確定'
      },
      form: {
        caId: '目錄名稱',
        name: '菜單組名稱',
        icon: '圖標',
        seq: '順序',
        storeType: '商戶類型',
        url: '頁面',
        isShow: '是否顯示',
        createTime: '創建時間',
      },
      table: {
        caId: '目錄名稱',
        name: '菜單組名稱',
        icon: '圖標',
        seq: '順序',
        storeType: '商戶類型',
        url: '頁面',
        isShow: '是否顯示',
        createTime: '創建時間',
      },
      validate: {
        caId: '請輸入目錄名稱',
        name: '請輸入菜單組名稱',
        icon: '請輸入圖標',
        seq: '請輸入順序',
        url: '請輸入頁面',
        isShow: '請輸入是否顯示',
        createTime: '請輸入創建時間',
      },
      add: {
        success: '添加菜單目錄成功'
      },
      edit: {
        success: '編輯菜單目錄成功'
      },
      delete: {
        success: '刪除菜單目錄成功',
        confirm: '確認刪除該菜單目錄嗎？'
      },
      fetchError: '獲取菜單目錄列表失敗',
      menuGropBtn:'菜單組'
    }
  }
}